<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 32 32"><path fill="currentcolor" d="m20 24-10-8 10-8z"/></svg>